
import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import UserServices from './UserServices';
import Pagination from '../Header/Pagination';
import MoveToTeam from './moveToTeam';

export function AddUser (param:any) {

    const [setting , setSetting] = React.useState<any[]>([]);
    const [isOpen, setIsOpen] = React.useState(false);
    const toggleDrawer = () => {
        setIsOpen(!isOpen)
    }
    const [contactArtist,SetContactArtist] = React.useState<any[]>([]); 
    const [TeamContacts ,SetTeamContacts ] = React.useState<any[]>([]); 
    const [totalRows_search,setTotalRowsSearch] = useState(1);
    const [totalRows_Team ,setTotalRowsTeam] = useState(1);
    let [moveBtnShow , setMoveBtnShow] = React.useState<any[]>([]);
    let [moveBtn ,setMoveBtn] = useState(false);
    let btn_move = Object.fromEntries(moveBtnShow); 
    var dataLink = "pageSize=10&pageNumber=1"; 
    const search =(e:any) => {
      
    }

    var Data  = {
        contactNameOrCode: "",
        digitalOnly: "",
        projectId: param.data.projectId,
        pageNumber: 1,
        pageSize: 10
    }

    const listMyTeam:any =  {
        pageSize : 10,
        pageNumber : 1 ,
        projectId: param.data.projectId
    } 
    const handleNameOnChange = (n: any) => {  
        Data.pageNumber = n.pageNumber;
        Data.pageSize =n.pageSize;
        apiCall()
    }
    
    const handleNameOnChangeTeam = (n: any) => {  
        listMyTeam.pageNumber = n.pageNumber;
        listMyTeam.pageSize =n.pageSize;
        apiCall()
    }

    const apiCall = () => {
        var contactArtist_link = '&digitalOnly='+'&projectId='+Data.projectId+'&pageNumber='+Data.pageNumber+'&pageSize='+Data.pageSize

        UserServices.contactArtist(contactArtist_link)
        .then( res => {
            SetContactArtist(res);
            setTotalRowsSearch(res[0].totalRows);
        })

        
        dataLink = 'projectId='+param.data.projectId+ '&pageSize=' + listMyTeam.pageSize +'&pageNumber=' + listMyTeam.pageNumber;
        UserServices.UserListing(dataLink)
        .then( res => {
            
            if(res === null){
                SetTeamContacts([]);
                setTotalRowsTeam(0)
            }else{
                SetTeamContacts(res.contacts);
                setTotalRowsTeam(res.totalRows)
            }
            
        })
    }

    const remove = (e:any) => {
        UserServices.contactRemove(e.projectContactId);
        apiCall();
    }

    const move = (e:any , value:any) => {   

        moveBtnShow.push([value.kontactId , e.target.value])
        setMoveBtnShow(moveBtnShow);
        btn_move = Object.fromEntries(moveBtnShow);
        SetContactArtist (contactArtist)
        apiCall()
        if(e.target.value !== "" ){
            setMoveBtn(true)
            
           
        }else{
            setMoveBtn(false)
        }       
        //UserServices.contactRemove(e.projectContactId);
       // apiCall();
    }

    const closePanel = (e:any) => {
        apiCall();
        for(var i = 0 ; i < btn_move.length ; i++){
            console.log (btn_move[i])
        }
       // btn_move = [];
        //console.log ( btn_move )
    }
    return(
    <>   

        <button className={"icon-btn edit pull-right mb"} onClick={() => {setIsOpen(!isOpen); apiCall()} }>Add New User</button>

        <Drawer open={isOpen}
        onClose={toggleDrawer}
        direction='right'
        className='react-drawer allowVscroll'
        size={1000}>

            <div className='ps landing ws-12 '>
                <div className="box">
                    <div className="box-header">
                        <h2 className="ws-10"><i className="icon-bar-chart"></i> Project Details ({param.data.projectName})</h2>
                        <i className="icon-close pull-right pLarge" onClick={() => setIsOpen(!isOpen) }></i>

                    </div>

                    <div className="box-content">
                        <div className="form-format ws-4">
                            <h2 className="pts">Project Name : </h2>
                            <div className="label-entries">
                                <span className="pts ">{param.data.projectName}</span>
                            </div>
                        </div>

                        <div className="form-format ws-4">
                            <h2 className="pts">Project Code : </h2>
                            <div className="label-entries">
                                <span className="pts ">{param.data.projectCode}</span>
                            </div>
                        </div>

                        <div className="form-format ws-4">
                            <h2 className="pts">Project ID : </h2>
                            <div className="label-entries">
                                <span className="pts ">{param.data.projectId}</span>
                            </div>
                        </div>

                        <div className="form-format ws-4">
                            <h2 className="pts">License Type : </h2>
                            <div className="label-entries">
                                <span className="pts "></span>
                            </div>
                        </div>

                        <div className="form-format ws-4">
                            <h2 className="pts">Project Type : </h2>
                            <div className="label-entries">
                                <span className="pts ">{param.data.projectType}</span>
                            </div>
                        </div>
                    </div>

                </div>

                <div className='ws-12 mt'>
                    <div className='ws-6 pr'>
                        <div className='box mts'>

                            <div className="box-header">                        
    
                                <h2 className="ws-10"><i className="icon-bar-chart"></i>  Contact search ({totalRows_search})</h2>
                                <div className='hide'><a className="btn btn-small icon-btn edit btn-sm pull-right"><i className="icon-file-add"></i></a></div>
                               
                            </div>

                            <div className='box-content'>
                                <div className="ws-12 mt pm " >
                                    {
                                        contactArtist.map(post =>{
                                            return (
                                            <div className="box shadow pm mtl" >
                                                <div className="ws-2">
                                                    <div className="circularLogo text-center pull-left">
                                                        <img width="50" height="50" src={post.creatorImageTH}/>
                                                    </div>
                                                </div>
                                                <div className="ws-10">
                                                    <div className="ws-6 text-bold mts ">
                                                        {post.kontactDisplay} ({post.kontactCode})

                                                        <button className='icon-btn edit pull-right btn-xs mt mr hide' >
                                                            <i className="icon-angle-double-right"></i>
                                                        </button>
                                                    </div>                                                    

                                                    <div className="ws-6">
                                                        
                                                        <div className={((btn_move[post.kontactId]) && (Number(btn_move[post.kontactId]) >0 ) )? "":"hide"} >

                                                           <MoveToTeam param={{"kontactCode" :post.kontactCode , "projectId":param.data.projectId ,
                                                            "contactType" : (btn_move[post.kontactId]) ,"projectContactId":0  }} onChange={closePanel}   />
                                                          
                                                            <i className="icon-angle-double-right hide"></i>
                                                                   
                                                        </div>

                                                        <select className="pull-right full-height ws-10 "  name="contactType" onChange={(e)=>{move(e,post)}}>
                                                            <option value="0" >Choose Contact Type</option>
                                                            <option value="1" label="Creator">Creator</option>
                                                            <option value="2" label="Lawyer">Lawyer</option>
                                                            <option value="3" label="Accountant">Accountant</option>
                                                            <option value="4" label="Business Manager">Business Manager</option>
                                                            <option value="5" label="Artist Manager">Artist Manager</option>
                                                            <option value="6" label="Record Label">Record Label</option>
                                                            <option value="7" label="Publisher">Publisher</option>
                                                            <option value="8" label="Advisor">Advisor</option>
                                                        </select>
                                                    </div>
                                                    <div className="ws-12 mt hide">{post.emailAdd1}</div>
                                                    
                                                </div>
                                            </div>
                                            );
                                        })
                                    }
                                        
                                </div>

                                <div className='ws-12 mt'>                
                                    {     
                                        (() => {
                                            if(totalRows_search>1 && totalRows_search>10){
                                                return <Pagination onChange={handleNameOnChange} totalRows={totalRows_search} />
                                            }
                                            
                                        })()
                                    }
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className='ws-6 pls'>
                        <div className='box pull-left m0 ws-12'>
                            <div className="box-header bg-white">
                                <h2 ><i className="icon-bar-chart"></i> Team Contacts ({totalRows_Team})</h2>
                                <a className="icon-btn delete btn-xs caret pull-left hide">
                                    <i className="icon-angle-double-left"></i>
                                    Remove contacts to team
                                </a>
                            </div>

                            <div className="box-content">
                                 <div className="ws-12 mt pm " >
                                    {
                                        TeamContacts.map( post =>{
                                            return (
                                                <div className="ws-12 mt pm " >
                                                    <div className="box shadow pm !active"  >
                                                        <div className="ws-2">
                                                            <div className="circularLogo text-center pull-left">
                                                                <img width="50" height="50" src={post.kontactImage}/>
                                                            </div>
                                                        </div>
                                                        <div className="ws-10">
                                                            <div className="ws-12 text-bold mts ">
                                                            {post.contactName}( {post.kontactCode})
                                                                <button className="icon-btn delete pull-right btn-xs mt mr" onClick={() => remove(post)}>
                                                                    <i className="icon-angle-double-left"></i>
                                                                </button>
                                                                
                                                            </div>
                                                            <div className="ws-12 mt ">{post.contactTypeDesc} |</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>

                                <div className='ws-12 mt'>                
                                    {     
                                        (() => {
                                            if(totalRows_Team>1 && totalRows_Team>10){
                                                return <Pagination onChange={handleNameOnChangeTeam} totalRows={totalRows_Team} />
                                            }
                                            
                                        })()
                                    }
                                </div>
                                
                               
                            </div>



                        </div>
                    </div>

                </div>
                
            </div>

        </Drawer>

    </> 
    )
}